import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'smartPercent'
})
export class SmartPercentPipe implements PipeTransform {
	transform(value: number | null | undefined, isDecimal: boolean = false): string {
		if (value == null || !Number.isFinite(value) || isNaN(value)) {
			return '0%';
		}

		// If isDecimal is true, multiply by 100 (e.g., 0.5 becomes 50)
		const percentValue = isDecimal ? value * 100 : value;

		// Check if the value is an integer (has no meaningful decimal part)
		const isInteger = percentValue % 1 === 0;

		if (isInteger) {
			return `${Math.round(percentValue)}%`;
		} else {
			return `${percentValue.toFixed(1)}%`;
		}
	}
}
